<template>
  <div
    v-if="redesign"
    class="assets"
    :class="{ assets__flash: isAnimation }"
    :style="{
      '--flash-color': assetsBackgroundColorChanged,

      '--accent-color': borderColors,
    }"
  >
    <p class="assets__title">{{ title }}</p>
    <div class="assets__asset">
      <div class="assets__icons-wrapper">
        <img
          :src="src"
          alt="Src"
          :class="{
            'assets-row__icon--reward ': isAnimation,
          }"
        />

        <img
          v-if="ticketAnimation"
          :src="src"
          alt="Src"
          :class="[indicatorIconClass]"
          class="assets__second-ticket"
        />
      </div>
      <p>{{ formatNumber(value) }}</p>
    </div>
    <p
      v-if="reduceCost"
      class="assets__minus"
      :class="costAnimation && 'assets__vapor-spiral'"
    >
      -{{ spinCost }}
    </p>
  </div>
  <div
    v-else
    style="width: 60px; height: 20px"
    :class="{
      'custom-style': title === 'Tether',
      'assets-row': title !== 'Tether',
      assets__flash:
        HandleIncreaseAmountAnimation && !user.isLoginToTheCampaign,
    }"
    :style="{ '--flash-color': assetsBackgroundColorChanged }"
    @click="
      () => {
        if (title === 'Tether') {
          navigateTo('/profile', { replace: true })

          user.navbarTab = 'profile'
        }
      }
    "
  >
    <p class="assets__title">{{ formatNumber(value) }}</p>
    <span class="tooltip-text">{{ value }}</span>
    <img
      :src="src"
      alt="Src"
      class="assets-row__icon"
      :class="{
        'assets-row__icon--reward ':
          HandleIncreaseAmountAnimation && !user.isLoginToTheCampaign,
      }"
    />
    <img
      v-if="HandleDecreaseAmountAnimation && !user.isLoginToTheCampaign"
      :src="src"
      alt="Src"
      class="assets__vapor-spiral assets-row__second"
    />

    <img
      v-if="ticketAnimation"
      :src="src"
      alt="Src"
      :class="[indicatorIconClass]"
      class="assets-row__second-ticket"
    />
  </div>
</template>

<script setup>
const user = useUserStore()
const props = defineProps({
  title: { type: String, default: '' },
  src: { type: String, default: '' },
  value: { type: Number, default: 0 },
  spinAmount: { type: Number, default: 0 },
  spinCost: { type: Number, default: 0 },
  indicatorIconClass: { type: String, default: '' },
  ticketAnimation: { type: Boolean, default: false },
  reduceCost: { type: Boolean, default: false },
  costAnimation: { type: Boolean, default: false },
  isAnimation: { type: Boolean, default: false },
  redesign: { type: Boolean, default: true },
  isCoinAmountChanged: { type: String, default: null },
  isTetherAmountChanged: { type: String, default: null },
  isGemAmountChanged: { type: String, default: null },
  isTicketAmountChanged: { type: String, default: null },
  isBlueFireAmountChanged: { type: String, default: null },
  assetsBackgroundColorChanged: { type: String, default: '' },
  borderColors: { type: Object, default: null },
})

const HandleDecreaseAmountAnimation = computed(() => {
  if (
    (props.isCoinAmountChanged === 'decreaseCoin' && props.title === 'Coin') ||
    (props.isTetherAmountChanged === 'decreaseTether' &&
      props.title === 'Tether') ||
    (props.isGemAmountChanged === 'decreaseGem' && props.title === 'Gem') ||
    (props.isTicketAmountChanged === 'decreaseTicket' &&
      props.title === 'Ticket') ||
    (props.isBlueFireAmountChanged === 'decreaseBlueFire' &&
      props.title === 'Blue-fire')
  )
    return true
})
const HandleIncreaseAmountAnimation = computed(() => {
  if (
    (props.isCoinAmountChanged === 'increaseCoin' && props.title === 'Coin') ||
    (props.isTetherAmountChanged === 'increaseTether' &&
      props.title === 'Tether') ||
    (props.isGemAmountChanged === 'increaseGem' && props.title === 'Gem') ||
    (props.isTicketAmountChanged === 'increaseTicket' &&
      props.title === 'Ticket') ||
    (props.isBlueFireAmountChanged === 'increaseBlueFire' &&
      props.title === 'Blue-fire')
  )
    return true
})

const indicatorValue = ref(props.value)
// const isAnimation = ref(false)

// const finalIndicatorValue = computed(() => {
//   if (props.spinAmount > 0) {
//     const increaseIndicatorAmount = setInterval(() => {
//       if (indicatorValue.value === props.value + props.spinAmount) {
//         isAnimation.value = true
//         clearInterval(increaseIndicatorAmount)
//       } else {
//         indicatorValue.value = indicatorValue.value + 1
//       }
//     }, 150)
//     return indicatorValue.value
//   } else {
//     return (indicatorValue.value = props.value)
//   }
// })
</script>

<style lang="scss" scoped>
.assets {
  border: 1px solid transparent;
  background:
    linear-gradient(#000000, #000000) padding-box,
    linear-gradient(
        104.64deg,
        #000000 0%,
        var(--accent-color) 46.88%,
        #000000 99.49%
      )
      border-box;
  border-radius: 6px;
  width: 22%;
  padding: 15px 0;
  position: relative;
  &__title {
    color: $textColor;
    font-weight: 600;
    font-size: $small;
    font-weight: 400;
  }
  &__asset {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    p {
      //   font-family: 'Silkscreen';
      color: #fff;
      font-size: $small;
      font-weight: 700;
    }
    img {
      width: 16px;
      height: 16px;
    }
  }

  &__icons-wrapper {
    position: relative;
  }

  &__second-ticket {
    position: absolute;
    left: 0;
    bottom: 0;
  }

  &__minus {
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
    bottom: 15px;
    z-index: 1;
    color: #fff;
    //   font-family: 'Silkscreen';
    font-weight: 700;
    font-size: $body2;
    opacity: 0;
  }

  &__vapor-spiral {
    animation: vaporSpiral 4s ease-in-out;
    @keyframes vaporSpiral {
      0% {
        transform: translate(0, 0);
        opacity: 5;
      }
      25% {
        transform: translate(15px, -25px);
        opacity: 0.6;
      }
      50% {
        transform: translate(-30px, -50px);
      }
      75% {
        transform: translate(30px, -75px);
        opacity: 0.2;
      }
      100% {
        transform: translate(-45px, -100px);
        opacity: 0;
      }
    }
  }
  &__flash {
    border-radius: 6px;
    animation: bgFlash 0.6s ease-in-out;
    animation-delay: 0.5s;
    @keyframes bgFlash {
      0% {
        background: transparent;
      }
      50% {
        background: var(--flash-color);
        transition: opacity 1s all;
      }

      100% {
        background: transparent;
        transition: opacity 1s all;
      }
    }
  }
}

.assets-row {
  background: #ffffff3d;
}

.assets-row,
.custom-style {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  gap: 2px;
  position: relative;
  width: 59px;
  height: 20px;
  border-radius: 8px;

  p {
    font-size: 12px;
    font-weight: 700;
    color: #fff;
  }

  &__icon {
    width: 15px;
    transition: opacity 0.2s all;

    &--reward {
      opacity: 1;
      animation: rewardIcon 0.5s linear forwards;

      animation-delay: 0.8;

      @keyframes rewardIcon {
        0% {
          transform: scale(3);
        }
        20% {
          transform: scale(2.1);
        }
        30% {
          transform: scale(2);
        }
        70% {
          transform: scale(1.2);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }

  &__second-ticket {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 11px;
  }
  &__second {
    position: absolute;
    left: 27px;
    top: -1px;
    width: 11px;
  }
}

.custom-style {
  background: #00d3953d;
  width: 60px;
  height: 20px;
  justify-content: center;
  margin-right: 5px;
}

.custom-style .tooltip-text,
.assets-row .tooltip-text {
  visibility: hidden;
  width: 70px;
  background-color: #d9d9d9;
  color: #000;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  z-index: 1;
  top: 95%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.custom-style:hover .tooltip-text,
.assets-row:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
